export const getInitials = (name) => {
    return name.split(" ").map((n) => n[0].toUpperCase()).join("");
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Toolbar/utils.js